import React from 'react'
import Downshift from 'downshift'
import styled from 'styled-components/macro'
import { faAngleDown } from '@fortawesome/pro-solid-svg-icons/faAngleDown'
import { IconLarge } from '.'
import { Translate } from '../TranslationsContext'

const Container = styled.div`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;

  > div {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  ul {
    position: absolute;
    top: 31px;
    right: 0;
    background-color: '#fff';
    padding: 0;
    list-style: none;

    z-index: 1;
    background: white;
    box-shadow: 0 0 10px 0 #cfcfcf;
    padding: 8px 0;

    li {
      padding: 8px 16px;
      white-space: nowrap;

      transition: all 200ms;
      cursor: pointer;
    }

    &:after {
      position: absolute;
      z-index: 150;
      content: '';
      bottom: 100%;
      left: calc(50% - 6px);
      display: block;
      border-bottom: 8px solid #fff;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
    }
  }

  label {
    white-space: nowrap;
    color: #a2a2a2;

    margin-right: 4px;
  }

  button {
    display: flex;
    flex-direction: row;
    align-items: center;

    color: #303030;
    white-space: nowrap;
    background: transparent;
    border: none;
    padding: 4px;
    outline: none;
    cursor: pointer;
    transition: all 200ms;

    &:hover {
      color: #56a0d3;
      text-decoration: underline;
    }

    > span {
      margin-left: 4px;
    }
  }
`

type Props = {
  selectedItem: string
  options: Array<{ label: string; value: string }>
  onChange: (newSelectedItem: string) => void
}

export const SortBy: React.FC<Props> = ({ selectedItem, onChange, options }) => (
  <Container>
    <Downshift
      selectedItem={{ value: selectedItem }}
      onChange={(selection) => {
        if (selection == null) {
          throw new Error('Got unexpected deselection')
        }

        onChange(selection.value)
      }}
      itemToString={(item) => options.find((option) => option.value === item?.value)?.label ?? 'Unknown option'}
    >
      {({
        getInputProps,
        getItemProps,
        getMenuProps,
        getLabelProps,
        getToggleButtonProps,
        inputValue,
        highlightedIndex,
        selectedItem,
        isOpen
      }) => (
        <div>
          <label {...getLabelProps()}>
            <Translate id="sortBy" />:
          </label>
          <button {...getToggleButtonProps()} aria-label={'toggle menu'}>
            {options.find((option) => option.value === selectedItem?.value)?.label}

            <IconLarge icon={faAngleDown} />
          </button>

          <ul {...getMenuProps({})}>
            {isOpen &&
              options
                // .filter((item) => !inputValue || item.value.includes(inputValue))
                .map((item, index) => (
                  <li
                    {...getItemProps({
                      key: `${item.value}${index}`,
                      item,
                      index,
                      style: {
                        backgroundColor: highlightedIndex === index ? '#eee' : 'white',
                        fontWeight: selectedItem?.value === item.value ? 'bold' : 'normal'
                      }
                    })}
                  >
                    {item.label}
                  </li>
                ))}
          </ul>
        </div>
      )}
    </Downshift>
  </Container>
)
